/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiResult,
    BaseReportRequest,
    Nem12ReportRequest,
    TransactionReportRequest,
    WebhookDto,
} from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    BaseReportRequestFromJSON,
    BaseReportRequestToJSON,
    Nem12ReportRequestFromJSON,
    Nem12ReportRequestToJSON,
    TransactionReportRequestFromJSON,
    TransactionReportRequestToJSON,
    WebhookDtoFromJSON,
    WebhookDtoToJSON,
} from "../models/index";

export interface RunCarbonEmissionReportRequest {
    body: BaseReportRequest;
}

export interface RunFaultedDeviceReportRequest {
    body: BaseReportRequest;
}

export interface RunNem12ReportRequest {
    body?: Nem12ReportRequest;
}

export interface RunOfflineDeviceReportRequest {
    body: BaseReportRequest;
}

export interface RunTransactionReportRequest {
    body?: TransactionReportRequest;
}

export interface RunUptimeReportRequest {
    body: BaseReportRequest;
}

export interface RunVehicleReportRequest {
    body: BaseReportRequest;
}

export interface WebhookDeleteRequest {
    webhookId: number;
}

export interface WebhookTriggerRequest {
    webhookId: number;
    timestamp?: string;
}

export interface WebhookUpdateRequest {
    body?: WebhookDto;
}

export interface WebhooksInsertRequest {
    body?: WebhookDto;
}

/**
 *
 */
export class WebhookHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Run an ad-hoc CarbonEmissionReport
     */
    async runCarbonEmissionReportRaw(
        requestParameters: RunCarbonEmissionReportRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters["body"] == null) {
            throw new runtime.RequiredError(
                "body",
                'Required parameter "body" was null or undefined when calling runCarbonEmissionReport().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/reports/carbon-emission`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: BaseReportRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Run an ad-hoc CarbonEmissionReport
     */
    async runCarbonEmissionReport(
        requestParameters: RunCarbonEmissionReportRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Blob> {
        const response = await this.runCarbonEmissionReportRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Run an ad-hoc FaultedDeviceReport
     */
    async runFaultedDeviceReportRaw(
        requestParameters: RunFaultedDeviceReportRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters["body"] == null) {
            throw new runtime.RequiredError(
                "body",
                'Required parameter "body" was null or undefined when calling runFaultedDeviceReport().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/reports/faulted-device`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: BaseReportRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Run an ad-hoc FaultedDeviceReport
     */
    async runFaultedDeviceReport(
        requestParameters: RunFaultedDeviceReportRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Blob> {
        const response = await this.runFaultedDeviceReportRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Run an ad-hoc Nem12 Report
     */
    async runNem12ReportRaw(
        requestParameters: RunNem12ReportRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/reports/nem12`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: Nem12ReportRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Run an ad-hoc Nem12 Report
     */
    async runNem12Report(
        requestParameters: RunNem12ReportRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Blob> {
        const response = await this.runNem12ReportRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Run an ad-hoc OfflineDeviceReport
     */
    async runOfflineDeviceReportRaw(
        requestParameters: RunOfflineDeviceReportRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters["body"] == null) {
            throw new runtime.RequiredError(
                "body",
                'Required parameter "body" was null or undefined when calling runOfflineDeviceReport().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/reports/offline-device`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: BaseReportRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Run an ad-hoc OfflineDeviceReport
     */
    async runOfflineDeviceReport(
        requestParameters: RunOfflineDeviceReportRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Blob> {
        const response = await this.runOfflineDeviceReportRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Run an ad-hoc TransactionReport
     */
    async runTransactionReportRaw(
        requestParameters: RunTransactionReportRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/reports/transaction`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: TransactionReportRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Run an ad-hoc TransactionReport
     */
    async runTransactionReport(
        requestParameters: RunTransactionReportRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Blob> {
        const response = await this.runTransactionReportRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Run an ad-hoc UptimeReport
     */
    async runUptimeReportRaw(
        requestParameters: RunUptimeReportRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters["body"] == null) {
            throw new runtime.RequiredError(
                "body",
                'Required parameter "body" was null or undefined when calling runUptimeReport().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/reports/uptime`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: BaseReportRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Run an ad-hoc UptimeReport
     */
    async runUptimeReport(
        requestParameters: RunUptimeReportRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Blob> {
        const response = await this.runUptimeReportRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Run an ad-hoc VehicleReport
     */
    async runVehicleReportRaw(
        requestParameters: RunVehicleReportRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters["body"] == null) {
            throw new runtime.RequiredError(
                "body",
                'Required parameter "body" was null or undefined when calling runVehicleReport().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/reports/vehicle`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: BaseReportRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Run an ad-hoc VehicleReport
     */
    async runVehicleReport(
        requestParameters: RunVehicleReportRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Blob> {
        const response = await this.runVehicleReportRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Delete Webhook
     */
    async webhookDeleteRaw(
        requestParameters: WebhookDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["webhookId"] == null) {
            throw new runtime.RequiredError(
                "webhookId",
                'Required parameter "webhookId" was null or undefined when calling webhookDelete().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/webhooks/{webhookId}`.replace(
                    `{${"webhookId"}}`,
                    encodeURIComponent(String(requestParameters["webhookId"])),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Delete Webhook
     */
    async webhookDelete(
        requestParameters: WebhookDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.webhookDeleteRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Trigger a webhook. Specify Timestamp for Report webhook types, to generate the correct report for that time (including for historic reports). Other webhook types will be triggered with default data.
     */
    async webhookTriggerRaw(
        requestParameters: WebhookTriggerRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["webhookId"] == null) {
            throw new runtime.RequiredError(
                "webhookId",
                'Required parameter "webhookId" was null or undefined when calling webhookTrigger().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["timestamp"] != null) {
            queryParameters["timestamp"] = requestParameters["timestamp"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/webhooks/{webhookId}/trigger`.replace(
                    `{${"webhookId"}}`,
                    encodeURIComponent(String(requestParameters["webhookId"])),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Trigger a webhook. Specify Timestamp for Report webhook types, to generate the correct report for that time (including for historic reports). Other webhook types will be triggered with default data.
     */
    async webhookTrigger(
        requestParameters: WebhookTriggerRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.webhookTriggerRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update existing Webhook
     */
    async webhookUpdateRaw(
        requestParameters: WebhookUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/webhooks`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: WebhookDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Update existing Webhook
     */
    async webhookUpdate(
        requestParameters: WebhookUpdateRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.webhookUpdateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Register a new Webhook endpoint. Both REST (http(s)) and email (mailto) uris are supported. *NOTE*: The response type for *this* call is documented at the HTTP 200 response. The webhook payload types are documented only in the ChargeDataApi documentation for the equivalent endpoint.
     */
    async webhooksInsertRaw(
        requestParameters: WebhooksInsertRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/webhooks`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: WebhookDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Register a new Webhook endpoint. Both REST (http(s)) and email (mailto) uris are supported. *NOTE*: The response type for *this* call is documented at the HTTP 200 response. The webhook payload types are documented only in the ChargeDataApi documentation for the equivalent endpoint.
     */
    async webhooksInsert(
        requestParameters: WebhooksInsertRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.webhooksInsertRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * OData query for all non-deleted webhooks
     */
    async webhooksListOdataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<WebhookDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/webhooks-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(WebhookDtoFromJSON),
        );
    }

    /**
     * OData query for all non-deleted webhooks
     */
    async webhooksListOdata(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<WebhookDto>> {
        const response = await this.webhooksListOdataRaw(initOverrides);
        return await response.value();
    }
}
